var $46a885db3b44ea95$exports = {};
$46a885db3b44ea95$exports = {
  "buttonLabel": "Afi\u0219are sugestii",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " op\u021Biune");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " op\u021Biuni");
      }
    }), " disponibile.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Grup ".concat(args.groupTitle, " introdus, cu ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " op\u021Biune");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " op\u021Biuni");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", selectat",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Sugestii",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", selectat");
  }
};
export { $46a885db3b44ea95$exports as default };